import React, { Suspense } from 'react';
import Spinner from 'react-bootstrap/Spinner'
import ReactDOM from 'react-dom';
import { InteractiveRenderer, Interactive, deepMap, hydrate } from '@bittnerdevelopmentgroup/interactive-builder'
import { HashRouter as Router, Routes, Route, Link, useParams } from "react-router-dom"
import PartialTest from './PartialTest';
import './index.scss';

const interactives = [
  /*{
    name: "Test Interactive",
    path: "/test-interactive",
    Component: React.lazy(()=>import('./pages/test/Test.jsx')),
    //Component: <Test/>,
  },
  {
    name: "Plants",
    path: "/plants",
    Component: React.lazy(()=>import('./pages/plants/plants.jsx')),
    //Component: <Test/>,
  }*/
]


const context = require.context('../public/interactives', true, /\.yml$/)
const context_paths = {}
const context_interactives = []
context.keys().forEach(k=>{
  const name = k.substr(2, k.length - 6)
  if (!name.endsWith(".manifest")) {
    context_interactives.push(name)
    context_paths[name] = k.substr(2)
  }
})
const context2 = require.context('../public/interactives', true, /\.json$/)
context2.keys().forEach(k=>{
  const name = k.substr(2, k.length - 7)
  if (!name.endsWith(".manifest")) {
    context_interactives.push(name)
    context_paths[name] = k.substr(2)
  }
})


const AdminPage = React.lazy(() => import('./AdminPage'));

function loadFetchedInteractive(r) {
  let i = new Interactive({
    ...r,
    panels: deepMap(r.panels, hydrate),
  })
  return i
}

function Path({partialTest}) {
  let { name } = useParams()
  let path = context_paths[name]
  console.log("Path", path)
  const [data, setData] = React.useState()
  const [error, setError] = React.useState()
  React.useEffect(()=>{
    if (data === undefined) {
      console.log("Path loading", `../public/interactives/${path}`)
      import(`../public/interactives/${path}`).then(data => {
        console.log("data", data)
        if (path.endsWith(".json")) {
          data.default.panels = data.default.panels.map(JSON.parse)
          setData(loadFetchedInteractive(data?.default))
        } else {
          setData(loadFetchedInteractive(data?.default?.interactive))
        }
      }).catch(e=>{
        console.log("Error", e)
        setError(e.message)
      })
    }
    return ()=>{
      console.log("Path unload")
    }
  }, [data, name, path])
  if (data) {
    console.log("staging data", name)
    if (partialTest) {
      return <PartialTest data={data}/>
    }
    return <InteractiveRenderer fullWidth attributes={{interactiveId: name}} data={data}/>
  }
  if (error) {
    return <code style={{whiteSpace: 'pre', color: 'red'}}>{error}</code>
  }
  return <Spinner animation="border"/>
}

function LandingPage(props) {
  console.log("LandingPage")
  //const [names, setNames] = React.useState(context_interactives);
  /*React.useEffect(()=>{
    impo//rt('./index.json').then(r=>{
      console.log("import r", r)
      let arr = names.slice()
      for (const i of r.interactives) {
        arr.push(i.substring(0, i.length - 5));
      }
      setNames(arr);
    }).catch(e=>{
      throw e;
    })
  }, [])*/
  return <div style={{width: '540px', margin: 'auto'}}>
    <h2>Product Name</h2>
    <ul>
      {context_interactives.map(name=>{
        return <li>
          <Link to={`/${name}`}>{name}</Link>
        </li>
      })}
      {interactives.map(({name, path}) => {
        return <li key={path}>
          <Link to={path}>{name}</Link>
        </li>
      })}
      {/*<li>
        <Link to={`/partialTest`}>partialTest</Link>
    </li>*/}
    </ul>
    <span className="bdg-link">
      <Link to={`/collections/interactives`}>BDG</Link>
    </span>
  </div>
}

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Suspense fallback={<Spinner animation="border"/>}>
        <Routes>
          {/*<Route exact path="/partialTest" element={<Path name="voices-of-freedom" partialTest/>}/>*/}
          <Route path="/collections/*" element={<AdminPage/>}/>
          <Route exact path="/" element={<LandingPage/>}/>
          <Route path={`/:name`} element={<Path/>}/>
        </Routes>
      </Suspense>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
